var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quote-container"},[_c('div',{staticClass:"vertical-line"}),_c('div',{ref:"comment",staticClass:"quote-content"},[_c('Typography',{attrs:{"variant":"caption"}},[_vm._v(_vm._s(_vm.text))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }